module.exports = __webpack_public_path__ + "files/c7bc3a23b67bebc3cdd7c03222b3cdf5.png";